<template>
  <v-row>
    <v-col class="d-inline-flex align-center" cols="12">
      <v-dialog v-model="dialog" max-width="800" scrollable persistent transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on">
            <v-icon id="gas">{{ icon }}</v-icon>{{ phrase.title_gas }}
          </v-btn>
        </template>

        <v-card height=400>
          <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_gas }}</v-card-title>
          <v-card-text style="white-space: pre-line">
            <div class="my-5 text--primary">{{ help_gas_text }}</div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-start">
            <v-btn color="primary" text @click="dialog = false">
              {{ phrase.dialog_close }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-select
        class="d-inline-flex align-center ml-4"
        :disabled="!hasHouseSelected"
        :items="peopleOptions"
        item-text="text"
        item-value="value"
        :value="$store.state.people_gas"
        label="家族人数"
        @change="select_people_gas"
      ></v-select>
      <v-select :key="planSelectKey" class="d-inline-flex align-center ml-2" :disabled="!hasHouseSelected || !hasSelectedPeople" :items=sortedGas item-text="select" item-value="cost" :label="this.$store.state.select.gas" return-object @change="select_gas"></v-select>
        <span class="ml-4 font-weight-bold header-total-inline">合計 {{ (this.$store.state.breakdown.gas).toLocaleString() }}円</span>
    </v-col>
    <v-col cols="12">
      <v-card min-height="100%" min-width="80%">
        <v-card-title>{{ phrase.cost_gas }}</v-card-title>
        <v-layout justify-center>
          <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/gas/gas.jpg')"></v-img>
        </v-layout>
        <v-card-subtitle>住宅: {{ selectedHouseSelect }}</v-card-subtitle>
        <v-card-title>{{ this.$store.state.breakdown.gas.toLocaleString() }}円</v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import words from '../assets/words.json'

export default({
  data: () => ({
    icon: 'mdi-fire',
    dialog: false,
    phrase: {}
  }),
  mounted: function () {
    this.getWords()
  },
  computed: {
    peopleOptions() {
      return [
        { text: '1人', value: 1 },
        { text: '2人', value: 2 },
        { text: '3人', value: 3 },
        { text: '4人', value: 4 }
      ];
    },
    hasHouseSelected() {
      return !!this.$store.state.selected_house;
    },
    hasSelectedPeople() {
      return Number(this.$store.state.people_gas) >= 1;
    },
    sortedGas() {
      return this.sortGas();
    },
    help_gas_text () {
      return this.phrase.help_gas
    },
    selectedHouseSelect () {
      const house = this.$store.state.selected_house || {}
      return house.select || '-'
    },
    planSelectKey () {
      const house = this.$store.state.selected_house || {}
      const houseKey = house.key || house.id || house.select || 'none'
      return `gas-${houseKey}-${this.$store.state.people_gas}`
    }
  },
  methods: {
    sortGas() {
      const list = this.$store.state.login_response.gas || [];
      const selectedPeople = Number(this.$store.state.people_gas);
      if (!(selectedPeople >= 1)) return [];
      return list
        .filter((item) => Number(item.people) === selectedPeople)
        .slice()
        .sort((a, b) => { return (Number(a.order) || 0) - (Number(b.order) || 0); });
    },
    select_people_gas: function(people) {
      this.$store.commit('set_utility_people', { kind: 'gas', people });
      this.$store.commit('clear_utility_plan', { kind: 'gas' });
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    select_gas: function(select) {
      console.log('value', select);
      if (!select) {
        this.$store.commit('clear_utility_plan', { kind: 'gas', selectLabel: '使用量' });
      } else {
        this.$store.commit('value_gas', select);
      }
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    getWords: function () {
      this.phrase = words
    }
  }
})
</script>
